import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAppSelector } from "store/hooks"
import "./CustomDrawer.scss"
const NavItems = [
    {
        title: "CONNECT",
        items: [
            {
                label: "Events",
                href: "/connect",
                anchor: false
            },
            {
                label: "Volunteer",
                href: "/connect?section=volunteer",
                anchor: false
            },
            {
                label: "Partnership Opportunities",
                href: "/connect?section=partnership-opportunities",
                anchor: false
            },
            {
                label: "Discussion Forum",
                href: "/discussion-forum",
                anchor: false
            }
        ],
    },
    {
        title: "PREPARE",
        items: [
            {
                label: "GRE Prep Program",
                href: "/gre",
                anchor: false
            },
            {
                label: "How Our Course Works",
                href: "/how-our-course-works",
                anchor: false
            },
            {
                label: "Partner Discounts",
                href: "/partners",
                anchor: false
            },
            {
                label: "FAQs",
                href: "/faq",
                anchor: false
            },
        ],
    },
    {
        title: "ADVICE",
        items: [
            {
                label: "What You Should Know Before Applying",
                href: "/foresee-items",
                anchor: false
            },
            {
                label: "Timeline",
                href: "/timeline",
                anchor: false
            },
            {
                label: "Do I Need the GRE?",
                href: "/gre-need",
                anchor: false
            },
            {
                label: "Choosing Between the GRE and GMAT",
                href: "/gre-or-gmat",
                anchor: false
            },
        ],
    },
    {
        title: "ABOUT US",
        items: [
            {
                label: "Our Mission",
                href: "/our-mission",
                anchor: false
            },
            {
                label: "Our Board of Directors",
                href: "/meet-our-leaders",
                anchor: false
            },
            {
                label: "Annual Report",
                href: 'annual-report',
                anchor: false
            },
            {
                label: "Donate",
                href: "https://givebutter.com/Vo9aqn",
                anchor: true
            },
            {
                label: "Contact Us",
                href: "/contact-us",
            },
        ],
    },
]
const CustomDrawer = () => {
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAppSelector((state) => state.user)
    const onStudentPortalClickHandler = () => {
        if (isAuthenticated && user?.role === "Student") {
            navigate("/student");
        }
        else {
            navigate("/portal")
        }
    }
    return (
        <div className="CustomDrawer">
            <div className="CustomDrawer__nav">
                {NavItems.map((navItem) => (
                    <div className="navSection" key={navItem.title}>
                        <h2 className="title">{navItem.title}</h2>
                        <div className="dropDownMenu">
                            {navItem.items.map((item) => (
                                <>
                                    {item.anchor ?
                                        <a href={item.href} target="_blank" rel="noopener noreferrer" className="anchorItem">{item.label}</a>
                                        :

                                        <Link
                                            rel="noopener noreferrer"
                                            className="anchorItem"
                                            key={item.label}
                                            to={item.href}
                                        >
                                            {item.label}
                                        </Link>
                                    }
                                </>
                            ))}
                        </div>
                    </div>
                ))}
                <a className="portalBtn" onClick={onStudentPortalClickHandler}>Student Portal</a>
            </div>
        </div>
    )
}

export default CustomDrawer
